// ============================================================================
// view.sheepHome — migrated off the global read
// ============================================================================
// The Sheep dashboard owns its direct session/entry, active flock, recent
// daily, and fail-soft processing-batch reads through sheep.home.core. Header
// and the opt-in UsersModal remain shared shell/user-interaction sidecars; this
// declaration does not make the route boot-independent.
// ============================================================================

import type {MigratedSurfaceDeclaration} from '../surfaceDataManifest';

const declaration: MigratedSurfaceDeclaration = Object.freeze({
  surface: 'view.sheepHome',
  obligations: Object.freeze([Object.freeze({id: 'sheep.home.core', owner: 'permanent'})]),
  residualLegacy: Object.freeze([]),
});

export default declaration;
